const path = 'redux/databaseBackups';
export const SNAPSHOTS_LOADED = `${path}/SNAPSHOTS_LOADED`;

